"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CosmwasmMethods = void 0;
var CosmwasmMethods;
(function (CosmwasmMethods) {
    CosmwasmMethods["signAndBroadcast"] = "signAndBroadcast";
    CosmwasmMethods["getChainId"] = "getChainId";
    CosmwasmMethods["getHeight"] = "getHeight";
    CosmwasmMethods["getAccount"] = "getAccount";
    CosmwasmMethods["getSequence"] = "getSequence";
    CosmwasmMethods["getBlock"] = "getBlock";
    CosmwasmMethods["getBalance"] = "getBalance";
    CosmwasmMethods["getTx"] = "getTx";
    CosmwasmMethods["searchTx"] = "searchTx";
    CosmwasmMethods["broadcastTx"] = "broadcastTx";
    CosmwasmMethods["broadcastTxSync"] = "broadcastTxSync";
    CosmwasmMethods["getCodes"] = "getCodes";
    CosmwasmMethods["getCodeDetails"] = "getCodeDetails";
    CosmwasmMethods["getContracts"] = "getContracts";
    CosmwasmMethods["getContractsByCreator"] = "getContractsByCreator";
    CosmwasmMethods["getContract"] = "getContract";
    CosmwasmMethods["getContractCodeHistory"] = "getContractCodeHistory";
    CosmwasmMethods["queryContractRaw"] = "queryContractRaw";
    CosmwasmMethods["queryContractSmart"] = "queryContractSmart";
    CosmwasmMethods["txsQuery"] = "txsQuery";
})(CosmwasmMethods || (exports.CosmwasmMethods = CosmwasmMethods = {}));
//# sourceMappingURL=cosmwasm.js.map